var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "resetForm",
        staticClass: "sign-in",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onReset.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                _c("h2", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("account.resetPassword.title"))
                  }
                }),
                _vm._v(" "),
                _vm.resetResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.resetResponse.message,
                        type: _vm.resetResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.resetResponse.message = ""
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.isLoggedIn
                  ? _c("ValidationProvider", {
                      staticClass: "input-wrapper",
                      attrs: {
                        name: "currentPassword",
                        rules: "required",
                        tag: "div",
                        customMessages: {
                          required: _vm.$t("forms.errors.fieldEmpty")
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              var invalid = ref.invalid
                              var validated = ref.validated
                              var dirty = ref.dirty
                              return [
                                _c("FormInput", {
                                  attrs: {
                                    type: "password",
                                    autocomplete: "current-password",
                                    placeholder: _vm.$t(
                                      "forms.labels.currentPassword"
                                    ),
                                    label: _vm.$t(
                                      "forms.labels.currentPassword"
                                    ),
                                    error: invalid && validated,
                                    disabled: _vm.disabled,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.form.current,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "current", $$v)
                                    },
                                    expression: "form.current"
                                  }
                                }),
                                _vm._v(" "),
                                invalid && validated
                                  ? _c("span", {
                                      staticClass: "input-error",
                                      domProps: { innerHTML: _vm._s(errors[0]) }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "password",
                    rules: "required|complexpw",
                    vid: "password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      complexpw: _vm.$t("forms.errors.password")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: _vm.$t("forms.labels.newPassword"),
                                label: _vm.$t("forms.labels.newPassword"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.form.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "password", $$v)
                                },
                                expression: "form.password"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "confirm",
                    vid: "confirm",
                    rules: "required|confirmed:password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      confirmed: _vm.$t("forms.errors.passwordMatch")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: _vm.$t(
                                  "forms.labels.newPasswordRepeat"
                                ),
                                label: _vm.$t("forms.labels.newPasswordRepeat"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.form.confirm,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "confirm", $$v)
                                },
                                expression: "form.confirm"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("account.resetPassword.resetButton"),
                    disabled: _vm.disabled
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }